import {
  Modal,
  Form,
  Typography,
  InputNumber,
  Card,
  Select,
  Switch,
} from "antd";
import { layout } from "../../ViewInteresses/styles";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useAtualizarValor } from "../hooks/useAtualizarValor";

const { Title } = Typography;

const situacaoPropriedade = [
  //Array de Opções usadas no SELECT de dias da semana
  { id: 1, label: "Escriturado", value: "ESCRITURADO" },
  { id: 2, label: "Quitado", value: "QUITADO" },
  { id: 3, label: "Não Quitado", value: "NAO_QUITADO" },
  { id: 4, label: "Na Planta", value: "NA_PLANTA" },
];

export default function ModalEditarAnuncio({
  isModalOpen,
  handleFechar,
  cotaUsuarioId,
  valorVenda,
  valorCondominio,
  situacao,
  saldoDevedor,
  aceitaTroca,
}: any) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [formEdit] = Form.useForm();
  const [anuncioData, setAnuncioData] = useState<Partial<CotaUsuario>>({});
  const [minhaSituacao, setMinhaSituacao] = useState<string>();

  const { atualizar, isLoading, success, error, resetError, resetSuccess } =
    useAtualizarValor();

  const anuncioChange = (changedValues: any, allValues: any) => {
    if (allValues.situacao) {
      setMinhaSituacao(allValues.situacao);
    }
    setAnuncioData(allValues);
  };

  const { showSuccess, showError, contextHolder } = useMessage();
  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        window.location.reload();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
    handleFechar,
  ]);

  useEffect(() => {
    setMinhaSituacao(situacao);
  }, [situacao]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      cancelText="Cancelar"
      okText="Atualizar"
      onOk={() => atualizar(cotaUsuarioId, anuncioData)}
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        }, // Botão "Ativar" com fundo verde
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        }, // Botão "Cancelar" com fundo vermelho
      }}
    >
      <>
        <>{contextHolder}</>
        <Card
          title={
            isMobile ? (
              <Title
                level={4} // menor para mobile
                style={{
                  fontSize: "16px",
                  margin: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Editar
              </Title>
            ) : (
              <Title
                level={2} // maior para desktop
                style={{ margin: 0 }}
              >
                Editar
              </Title>
            )
          }
          style={{
            width: "100%",
            marginTop: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Form
            {...layout}
            form={formEdit}
            initialValues={{
              valorVenda,
              valorCondominio,
              situacao,
              saldoDevedor,
              aceitaTroca,
            }}
            onValuesChange={(changedValues, allValues) =>
              anuncioChange(changedValues, allValues)
            }
            name="editar-anuncio"
            preserve={false}
          >
            <Form.Item
              name={"situacao"}
              label="Situação da propriedade"
              className="formItems"
              style={{ width: "100%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Select placeholder="Situação da propriedade">
                {situacaoPropriedade.map((dias, index) => (
                  <Select.Option key={dias.id} value={dias.value}>
                    {dias.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name={"valorVenda"}
              label="Valor da Venda"
              rules={[{ required: true }]}
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <InputNumber
                placeholder="Digite o valor da venda"
                formatter={(value) => {
                  if (value === undefined || value === null) return "";
                  return `R$ ${Number(value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                }}
                parser={(value) => {
                  if (!value) return "";
                  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                    2
                  ); // Converte para decimal
                  return isNaN(Number(parsedValue)) ? "" : parsedValue;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="aceitaTroca"
              label="Aceita Troca"
              valuePropName="checked"
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Switch checkedChildren="Sim" unCheckedChildren="Não" />
            </Form.Item>

            <Form.Item
              name={"valorCondominio"}
              label="Valor do Condomínio"
              rules={[{ required: true }]}
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <InputNumber
                placeholder="Digite o valor do condomínio"
                formatter={(value) => {
                  if (value === undefined || value === null) return "";
                  return `R$ ${Number(value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                }}
                parser={(value) => {
                  if (!value) return "";
                  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                    2
                  ); // Converte para decimal
                  return isNaN(Number(parsedValue)) ? "" : parsedValue;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>

            {minhaSituacao === "NAO_QUITADO" && (
              <Form.Item
                name={["saldoDevedor"]}
                label="Saldo devedor"
                rules={[{ required: true }]}
                className="formItems"
                style={{ width: "60%", marginBottom: "24px" }}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <InputNumber<number>
                  placeholder="Digite o saldo devedor"
                  min={0.01}
                  formatter={(value) => {
                    if (value === undefined || value === null) return "";
                    return `R$ ${Number(value).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`;
                  }}
                  parser={(value) => {
                    if (!value) return 0;
                    const onlyNumbers = value.replace(/\D+/g, "");
                    const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                      2
                    );
                    return Number(parsedValue);
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            )}
          </Form>
        </Card>
      </>
    </Modal>
  );
}
